import React, { Component } from 'react'
import axios from "axios";
import ProgressBar from '../components/ProgressBar'
import { AiOutlineSearch, AiOutlineComment, AiOutlineCheck, AiOutlineReload } from "react-icons/ai"
import { BsBoxSeam } from "react-icons/bs"
import '../css/general-style.css'
import '../css/cycleInventory.css'
import '../css/dashboard.css'
import ModalOrders from '../components/ModalComponent';
// backv3 (temporal, regresar cuando backv3 esté listo): import { create_Delete_Update_Information, getInformationWithData } from '../services/CABE';
import { create_Delete_Update_Information, getInformationWithDataV2 } from '../services/CABE';
import Swal from "sweetalert2";
import { getValueCookie } from '../services/cookieService';
import { automaticCloseAlert } from '../functions/alerts'
import { CompareDates, DateFormatMAS90, formatInputDate, formatInputDateQuery, FormatQueryReturnDate, FormatQueryReturnDateWithDash, getActualDateUTC, getDateFromReports, getDateYearMonthDayDash, OrderArrayByDate } from '../functions/dateFormat'
import { getDataSet } from '../functions/generateDataSetExcel'
import ExcelDocument from '../components/ExcelDocument'
import Select from 'react-select';
import { getIndexElement } from '../functions/searchInObject'
import LoadingWindow from '../components/LoadingWindow';
import { ItemDesc } from '../functions/generalFunctions'
import { Menu } from '../components/Menu/Menu';
import server from "../services/Connection/backEndLink";

export default class CycleInvetory extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
        this.ProgrressBarRef = React.createRef();
    }

    state = {
        dataset: [{
            columns: [],
            data: []
        }],
        porcetaje: 0,
        General: {
            showModal1: false,
            showModal2: false,
            showModal3: false,
            showModal4: false,
            habilitar: false,
            chekvalue: '0',
            checkHistory: '0',
            selectedItem: '',
            selectedCycleInventory: null,
            secureTransaction: false,
            generalHistory: [],
            outBounds: [],
            purchaseOrders: [],
            generalHistoryFilter: [],
            oldCycleInventory: [],
            detailOldCycleSelected: [],
            detailOldCycleSelectedFilter: [],
            optionsSelect1: [{ value: 'All', label: 'All' }],


        },

        cycleInventoryStorage: {
            Header: {
                closeBy: null,
                createBy: '',
                days: 0,
                finishDate: '',
                id: 0,
                lastUpadeDate: '',
                realFinishDate: '',
                startDate: '',
                status: 0,
                updateBy: '',
                QuantityItems: 0,
                FilterQuantity: 0
            },
            Detail: [],
            DetailFilter: [],
            CheckedItems: [],
            actualTitleSearch: 'No Checked Items'
        },
        secureTransaction1: false,
        showOrderDetailModal: {},
        showOrderDetails: [],


    }
    valueSearchBar = async e => {
        let search = e.target.value
        this.getBySearchBar(search)
    }

    valueRadioButton = async e => {
        document.getElementById('searchCycleInv1').value = ""
        let stat = e.target.value
        const temporal = this.state.General
        temporal.chekvalue = stat
        this.setState({ General: temporal })
        this.getByStat(stat)
    }



    searchOlderCycleInventoryDetail = e => {
        let search = e.target.value


        var DetailFilter = this.state.General.detailOldCycleSelected.filter((item) => {
            if (item.ItemCode.toString().toLowerCase().includes(search.toLowerCase()) || item.BIN.toString().toLowerCase().includes(search.toLowerCase()) || item.status.toString().toLowerCase().includes(search.toLowerCase())) {
                return item
            } else {
                return null
            }
        })

        const temporal = this.state.General
        temporal.detailOldCycleSelectedFilter = DetailFilter

        this.setState({ General: temporal })
    }



    getBySearchBar(search) {

        if (search !== "" && this.state.General.chekvalue !== '-1') {
            if (this.state.General.chekvalue === '0' || this.state.General.chekvalue === '1') {
                var DetailFilter = this.state.cycleInventoryStorage.Detail.filter((item) => {
                    if ((item.ItemCode.toString().toLowerCase().includes(search.toLowerCase()) || item.productLine.toString().toLowerCase().includes(search.toLowerCase()) || item.BIN.toString().toLowerCase().includes(search.toLowerCase()) || item.Description.toString().toLowerCase().includes(search.toLowerCase())) && item.status.toString().toLowerCase().includes(this.state.General.chekvalue)) {
                        return item
                    } else {
                        return null
                    }
                })

                const temporal = this.state.cycleInventoryStorage
                temporal.DetailFilter = DetailFilter
                temporal.Header.FilterQuantity = DetailFilter.length
                this.setState({ cycleInventoryStorage: temporal })
            } else if (this.state.General.chekvalue === '2') {
                var DetailFilter4 = this.state.cycleInventoryStorage.Detail.filter((item) => {
                    if ((item.ItemCode.toString().toLowerCase().includes(search.toLowerCase()) || item.productLine.toString().toLowerCase().includes(search.toLowerCase()) || item.BIN.toString().toLowerCase().includes(search.toLowerCase()) || item.Description.toString().toLowerCase().includes(search.toLowerCase())) && item.status.toString().toLowerCase().includes("1") && item.difference !== 0) {
                        return item
                    } else {
                        return null
                    }
                })

                const temporal = this.state.cycleInventoryStorage
                temporal.DetailFilter = DetailFilter4
                temporal.Header.FilterQuantity = DetailFilter4.length
                this.setState({ cycleInventoryStorage: temporal })
            }
        } else if (search !== "") {

            var DetailFilter2 = this.state.cycleInventoryStorage.Detail.filter((item) => {
                if ((item.ItemCode.toString().toLowerCase().includes(search.toLowerCase()) || item.BIN.toString().toLowerCase().includes(search.toLowerCase()) || item.productLine.toString().toLowerCase().includes(search.toLowerCase()) || item.Description.toString().toLowerCase().includes(search.toLowerCase()))) {
                    return item
                } else {
                    return null
                }
            })

            const temporal = this.state.cycleInventoryStorage
            temporal.DetailFilter = DetailFilter2
            temporal.Header.FilterQuantity = DetailFilter2.length
            this.setState({ cycleInventoryStorage: temporal })

        } else {
            this.getByStat(this.state.General.chekvalue)
        }

    }

    getByStat(stat) {
        if (stat !== "-1") {
            if (stat === "0" || stat === "1") {
                var DetailFilter = this.state.cycleInventoryStorage.Detail.filter((item) => {
                    if (item.status.toString().toLowerCase().includes(stat.toLowerCase())) {
                        return item
                    } else {
                        return null
                    }
                })
                const temporal = this.state.cycleInventoryStorage
                if (stat === '0') {
                    temporal.actualTitleSearch = 'No Checked Items'
                } else {
                    temporal.actualTitleSearch = 'Checked Items'
                }
                temporal.DetailFilter = DetailFilter
                temporal.Header.FilterQuantity = DetailFilter.length
                this.setState({ cycleInventoryStorage: temporal })
            } else if (stat === "2") {

                var DetailFilter3 = this.state.cycleInventoryStorage.Detail.filter((item) => {
                    if (item.difference !== 0) {
                        return item
                    } else {
                        return null
                    }
                })
                const temporal = this.state.cycleInventoryStorage
                temporal.actualTitleSearch = 'Differences'
                temporal.DetailFilter = DetailFilter3
                temporal.Header.FilterQuantity = DetailFilter3.length
                this.setState({ cycleInventoryStorage: temporal })

            }


        } else {
            const temporal = this.state.cycleInventoryStorage
            temporal.actualTitleSearch = 'All items'
            temporal.DetailFilter = temporal.Detail
            temporal.Header.FilterQuantity = temporal.Detail.length
            this.setState({ cycleInventoryStorage: temporal })
        }

    }


    getCategory(stat) {
        var busqueda = ""
        switch (stat) {
            case "0":
                busqueda = "purchase"
                break;
            case "1":
                busqueda = "transferencia"
                break;
            case "2":
                busqueda = "ajuste"
                break;
            case "3":
                busqueda = "outbound"
                break;
            default:
                busqueda = ""
                break;
        }
        return busqueda;
    }



    async componentDidMount() {
        this.ProgrressBarRef.current.setValue(0);
        await this.getLastCycleInventory()
    }

    async getLastCycleInventory() {
        this.ModalLoading.current.showState(true);
        const data = {
            idcompany: getValueCookie('CompanyId')
        }
        const route = '/inventory/lastCycle/post';
        // backv3 (temporal, regresar cuando backv3 esté listo): const datos = await getInformationWithData(route, data)
        const datos = await getInformationWithDataV2(route, data)

        if (datos.status.code === 1) {
            if (datos.data.length > 0) {
                const temporal = this.state.cycleInventoryStorage
                temporal.Header = datos.data[0]

                if (temporal.Header.status === 0) {

                    await this.getDetailCycleInventory(temporal.Header.id, "actual")
                } else {
                    temporal.Detail = []
                    temporal.DetailFilter = []
                    await this.setState({ cycleInventoryStorage: temporal })
                }
            } else {
                const temporal = this.state.cycleInventoryStorage
                temporal.Header.status = 1
                await this.setState({ cycleInventoryStorage: temporal })
            }
        }
        this.ModalLoading.current.showState(false);

    }


    async getOldCycleInventory() {
        const data = {
            idcompany: getValueCookie('CompanyId')
        }
        const route = '/invertory/oldCycleInventorys/post';
        // backv3 (temporal, regresar cuando backv3 esté listo): const datos = await getInformationWithData(route, data)
        const datos = await getInformationWithDataV2(route, data)
        if (datos.status.code === 1) {
            if (datos.data.length > 0) {
                const temporal = this.state.General
                temporal.oldCycleInventory = datos.data
                await this.setState({ General: temporal })

            } else {
                const temporal = this.state.General
                temporal.oldCycleInventory = []
                await this.setState({ General: temporal })
            }
        }
    }

    mergeDataCheck(arrayChecked, allArray) {

        for (let a = 0; a < arrayChecked.length; a++) {
            for (let b = 0; b < allArray.length; b++) {
                if (arrayChecked[a].ItemCode === allArray[b].ItemCode && arrayChecked[a].status === 1) {
                    allArray[b] = arrayChecked[a]
                    break
                }
            }

        }
        return allArray
    }


    async getDetailCycleInventory(id, type) {
        const data = {
            id: id,
            idcompany: getValueCookie('CompanyId'),
            company: getValueCookie('Company')
        }

        // backv3 (temporal, regresar cuando backv3 esté listo): const datos = await getInformationWithData('/inventory/cycledetail/post', data)
        const datos = await getInformationWithDataV2('/inventory/cycledetail/post', data)

        if (type === "actual") {
            // backv3 (temporal, regresar cuando backv3 esté listo): const allinformation = await getInformationWithData('/inventory/allProductsCycle/post', data)
            const allinformation = await getInformationWithDataV2('/inventory/allProductsCycle/post', data)
            
            if (datos.status.code === 1 && allinformation.status.code === 1) {
                let realData = this.mergeDataCheck(datos.data, allinformation.data)
                realData = await ItemDesc(realData, 'Description', 'ItemCode')
                const temporal = this.state.cycleInventoryStorage
                temporal.Detail = realData
                temporal.DetailFilter = realData
                temporal.Header.QuantityItems = realData.length
                temporal.Header.FilterQuantity = realData.length
                await this.setState({ cycleInventoryStorage: temporal })
                const tempo = this.state.cycleInventoryStorage
                tempo.CheckedItems = await this.getCheckedItems()
                await this.setState({ cycleInventoryStorage: tempo })
                await this.getByStat('0')
                await this.completePercentage()
            }
        } else if (type === "old") {
            const temporal = this.state.General
            temporal.detailOldCycleSelected = datos.data
            temporal.detailOldCycleSelectedFilter = datos.data
            await this.setState({ General: temporal })
        }

    }
    getOldDetailCycleInventory(item) {
        const temporal = this.state.General
        temporal.selectedCycleInventory = item
        this.setState({ General: temporal })
        this.getDetailCycleInventory(item.id, "old")
    }


    enableTransaction() {
        const temporal = this.state.General
        temporal.secureTransaction = false
        this.setState({ General: temporal })
    }

    async disableTransaction() {
        const temporal = this.state.General
        temporal.secureTransaction = true
        await this.setState({ General: temporal })
    }


    async startNewCycleInventory() {
        this.disableTransaction()
        const data = {
            days: 0,
            idcompany: getValueCookie('CompanyId'),
            userName: getValueCookie('userName'),
            realDays: 0,
            CycleInfo: ''

        }
        await Swal.fire({
            title: 'New Cyclical Inventory',
            html: `
            
                <div class='text-start pText'>
                <p>Number of Days of Cyclical Inventory:</p>
                </div>
                <div class='text-center'>
                <input className="swal2-input text-center" id='CycleInvEstDays' type="number"/>
                </div>
                <div class='text-start pText'>
                <p>Cycle:</p>
                </div>
                <div class='text-center'>
                <input className="swal2-input text-center" id='CycleInvInfo' type="text"/>
                </div>                
           
    `,
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                let days = Swal.getPopup().querySelector('#CycleInvEstDays').value
                let CycleInfo = Swal.getPopup().querySelector('#CycleInvInfo').value
                data.days = days
                data.CycleInfo = CycleInfo
                var actualDate = new Date();
                var finishDate = new Date(actualDate.getTime() + Number(Number(days) * 86400000))
                var habilDays = 0
                while (actualDate <= finishDate) {
                    if (actualDate.getDay() === 0 || actualDate.getDay() === 6) {
                        habilDays++
                    }
                    actualDate = new Date(actualDate.getTime() + 86400000)
                }

                data.realDays = Number(data.days) + Number(habilDays)
                return await create_Delete_Update_Information('/invertory/newCycle/post', data)
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {

            if (result.isConfirmed) {
                await this.getLastCycleInventory()
                await Swal.fire({
                    title: `The Cyclical Inventory was created!`,
                })

            }
        })
        await this.enableTransaction()
    }

    async endCycleInventory() {
        this.disableTransaction()
        const data = {
            id: this.state.cycleInventoryStorage.Header.id,
            userName: getValueCookie('userName')
        }
        await Swal.fire({
            title: 'Do you want to end the actual Cyclical Inventory?',
            showDenyButton: true,
            backdrop: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
            allowOutsideClick: () => !Swal.isLoading()
        }).then(async (result) => {
            if (result !== null && result !== undefined) {
                if (result.isConfirmed) {
                    const res = await create_Delete_Update_Information('/invertory/closeCycle/post', data)
                    if (res.status.code === 1) {
                        await this.getLastCycleInventory()
                        Swal.fire('Cyclical inventory are closed!', '', 'success')
                        this.setState({ porcetaje: 0 })
                        this.ProgrressBarRef.current.setValue(0);

                    } else {
                        Swal.fire('Cyclical inventory could not be closed', '', 'error')
                    }

                } else if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info')
                }
            }

        })
        this.enableTransaction()
    }

    async setCycleInventoryDetailInfo(item, idQuant) {
        this.ModalLoading.current.showState(true);
        this.disableTransaction()
        const data = {
            ItemCode: item.ItemCode,
            BIN: item.BIN,
            company: getValueCookie('Company'),
            idCompany:getValueCookie('CompanyId')
        }

        // backv3 (temporal, regresar cuando backv3 esté listo): const resultquant = await getInformationWithData('/invertory/getQuantity/post', data)
        const resultquant = await getInformationWithDataV2('/invertory/getQuantity/post', data)
        if (resultquant.status.code === 1) {
            const temporal = this.state.cycleInventoryStorage
            const index = temporal.Detail.indexOf(item)
            var flag = true
            if (index !== -1) {

                if (temporal.Detail[index].idcycleInventoryHeader !== 0) {
                    flag = false
                }

                temporal.Detail[index].idcycleInventoryHeader = this.state.cycleInventoryStorage.Header.id

                temporal.Detail[index].countBy = getValueCookie('userName')
                temporal.Detail[index].date = getActualDateUTC()
                temporal.Detail[index].systemQuantity = resultquant.data[0].Quantity
                temporal.Detail[index].difference = temporal.Detail[index].realQuantity - resultquant.data[0].Quantity
                temporal.Detail[index].status = 1
                var response
                if (flag) {
                    response = await create_Delete_Update_Information('/invertory/insertDetailCycle/post', temporal.Detail[index])
                } else {
                    response = await create_Delete_Update_Information('/invertory/updateDetailCycle/post', temporal.Detail[index])
                }
                if (response.status.code === 1) {
                    await this.ModalLoading.current.showState(false);
                    automaticCloseAlert('correct', 'The item was check!')
                    await this.setState({ cycleInventoryStorage: temporal })
                    await this.completePercentage()
                } else {
                    await this.ModalLoading.current.showState(false);
                    automaticCloseAlert('incorrect', 'The item was not checked')
                    temporal.Detail[index].status = 0
                    temporal.Detail[index].countBy = ''
                }

            }
            const tempo = this.state.cycleInventoryStorage
            tempo.CheckedItems = await this.getCheckedItems()
            await this.setState({ cycleInventoryStorage: tempo })
            await this.enableTransaction()
        }

    }

    async updateCycleInventoryDetail(item) {
        const temporal = this.state.cycleInventoryStorage
        const index = temporal.Detail.indexOf(item)
        if (index !== -1) {
            temporal.Detail[index].countBy = null
            temporal.Detail[index].status = 0
            await this.setState({ cycleInventoryStorage: temporal })
        }

    }
    completePercentage() {
        this.setState({ porcetaje: 0 })
        var count = 0;
        var total = this.state.cycleInventoryStorage.Detail.length

        for (const item of this.state.cycleInventoryStorage.Detail) {
            if (item.status === 1)
                count++
        }

        for (let a = 0; a < ((count * 100) / total); a++) {
            this.addValue()
        }


    }

    textStatus(value) {
        if (value === 0) {
            return "Not checked"
        }
        return "Checked"
    }

    addValue() {
        let cantidad = this.state.porcetaje;
        cantidad++;
        this.setState({ porcetaje: cantidad });
        this.ProgrressBarRef.current.setValue(cantidad);
    }

    handleModalOpen = (modal) => {
        const temporal = this.state.General
        temporal[modal] = true
        this.setState({ General: temporal })
    }

    handleModalClose = (modal) => {
        const temporal = this.state.General
        temporal[modal] = false
        this.setState({ General: temporal })
    }


    async openOlCycleInventory() {
        const temporal = this.state.General
        temporal.detailOldCycleSelected = []
        temporal.detailOldCycleSelectedFilter = []
        temporal.selectedCycleInventory = null
        this.setState({ General: temporal })
        this.getOldCycleInventory()
        await this.handleModalOpen("showModal2")
    }

    async getInfoProduct() {

        this.ModalLoading.current.showState(true);
        this.setState({ secureTransaction1: true })
        var date1 = formatInputDate(document.getElementById('searchHistoryCycleInvDate1').value)
        var date2 = formatInputDate(document.getElementById('searchHistoryCycleInvDate2').value)
        const data = {
            ItemCode: this.state.General.selectedItem.ItemCode,
            Start: date1,
            End: date2,
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId')
        }


        //AQUI COLOCAR LAS LLAMADAS A LOS DATOS
        //const route = '/invertory/getGeneralHistory/post';
        //const generalHistoryData = await getInformationWithData('/invertory/getGeneralHistory/post', data)
        // backv3 (temporal, regresar cuando backv3 esté listo): const pickList = await getInformationWithData('/pickList/history/getByItemCode', data)
        const pickList = await getInformationWithDataV2('/pickList/history/getByItemCode', data)
        //const transfer = await getInformationWithData('/transfer/history/getByItemCode', data)
        // backv3 (temporal, regresar cuando backv3 esté listo): const purchase = await getInformationWithData('/purchase/history/getByItemCode', data)
        const purchase = await getInformationWithDataV2('/purchase/history/getByItemCode', data)
        // backv3 (temporal, regresar cuando backv3 esté listo): const adjust = await getInformationWithData('/adjustment/history/getByItemCode', data)
        const adjust = await getInformationWithDataV2('/adjustment/history/getByItemCode', data)
        //const InventStart = await getInformationWithData('/Items/getQuantityHistory', data2)
        //const InventEnd = await getInformationWithData('/Items/getQuantityHistory', data3)

        if (pickList.status.code === 1 && purchase.status.code === 1 && adjust.status.code === 1) {
           
            const categories = this.state.General
            categories.optionsSelect1 = [{ value: 'All', label: 'All' }]
            this.setState({ General: categories })
            await this.consolidateTable(pickList.data, purchase.data, adjust.data/*, generalHistoryData.data*/)
        }
        this.setState({ secureTransaction1: false })
        this.ModalLoading.current.showState(false);
    }

    async DeleteRepeatBins(data, information) {
        // backv3 (temporal, regresar cuando backv3 esté listo): const result = await getInformationWithData('/inventory/getDeletedBins/post', data)
        const result = await getInformationWithDataV2('/inventory/getDeletedBins/post', data)
        if (result.status.code === 1) {

            for (let it of result.data) {
                for (let a = information.length - 1; a >= 0; a--) {
                    if (information[a].BIN === it.BIN && CompareDates(formatInputDateQuery(information[a].fech), formatInputDateQuery(it.date))) {
                        information.splice(a, 1)
                    }
                }
            }

            return information
        } else {
            return []
        }
    }
    getDataMayorInventory(data, type) {
        var information = []
        for (const it of data) {
            const index = information.findIndex(element => {
                return String(element.BIN).toLowerCase() === it.BIN.toLowerCase()
            })
            if (index === -1) {
                if (type === 'Start') {
                    it.Type = 'Inventory Start'
                } else {
                    it.Type = 'Inventory End'
                }
                information.push(it)
            }
        }


        return information
    }



    async consolidateTable(outbounds, purchase, adjusts/*, generalHistory*/) {


        var InfoArray = []
       
        for (const row of outbounds) {
            const structure = {
                Type: '',
                NoOrder: '',
                Description: '',
                BIN: '',
                BIN2: '',
                QuantityOrder: '',
                QuantityShipped: '',
                User: '',
                Date: '',
                CustomerName: '',
                CustomerNo: ''
            }

            structure.CustomerName = row.Cliente
            structure.CustomerNo = row.NoCliente
            structure.Type = row.Type
            structure.NoOrder = row.OrdenNo
            structure.Description = row.description
            structure.BIN = row.BIN
            structure.BIN2 = null
            structure.QuantityOrder = row.QuantityOrder
            structure.QuantityShipped = row.QuantityShipped
            structure.User = row.username

            if (FormatQueryReturnDate(row.Date).split("/").length === 3) {
                structure.Date = FormatQueryReturnDate(row.Date)
            } else {
                structure.Date = DateFormatMAS90(row.Date)
            }


            InfoArray.push(structure)

        }

        /*

        for (const row of transfers) {
            const structure = {
                Type: '',
                NoOrder: '',
                Description: '',
                BIN: '',
                BIN2: '',
                QuantityOrder: '',
                QuantityShipped: '',
                User: '',
                Date: ''
            }
            structure.Type = row.Type
            structure.Description = row.description
            structure.NoOrder = null
            structure.BIN = row.BINSalida
            structure.BIN2 = row.BINEntrada
            structure.QuantityOrder = 0
            structure.QuantityShipped = row.Quantity
            structure.User = row.username
            structure.Date = FormatQueryReturnDate(row.Date)
            InfoArray.push(structure)

        }
        */
        for (const row of purchase) {
            const structure = {
                Type: '',
                NoOrder: '',
                Description: '',
                BIN: '',
                BIN2: '',
                QuantityOrder: '',
                QuantityShipped: '',
                User: '',
                Date: '',
                CustomerName: '',
                CustomerNo: ''
            }
            structure.Type = row.Type
            structure.CustomerNo = row.VendorNo
            structure.CustomerName = row.VendorName
            structure.NoOrder = row.OrdenNo
            structure.BIN = row.BIN
            structure.Description = row.description
            structure.BIN2 = null
            structure.QuantityOrder = row.Quantity
            structure.QuantityShipped = null
            structure.User = row.username

            if (FormatQueryReturnDate(row.Date).split("/").length === 3) {
                structure.Date = FormatQueryReturnDate(row.Date)
            } else {
                structure.Date = DateFormatMAS90(row.Date)
            }
            InfoArray.push(structure)

        }

        for (const row of adjusts) {
            const structure = {
                Type: '',
                NoOrder: '',
                BIN: '',
                BIN2: '',
                QuantityOrder: '',
                QuantityShipped: '',
                User: '',
                Date: ''
            }
            structure.Type = row.Type
            structure.NoOrder = null
            structure.BIN = row.BIN
            structure.BIN2 = null
            structure.QuantityOrder = row.OldQuantity
            structure.QuantityShipped = row.NewQuantity
            structure.User = row.username
            structure.Description = row.Comment

            if (FormatQueryReturnDate(row.Date).split("/").length === 3) {
                structure.Date = FormatQueryReturnDate(row.Date)
            } else {
                structure.Date = DateFormatMAS90(row.Date)
            }
            InfoArray.push(structure)

        }



        var n = await OrderArrayByDate(InfoArray)

        var actualTypes = this.state.General.optionsSelect1
        for (const row of n) {
            const ind = getIndexElement(actualTypes, "value", row.Type)
            if (ind === -1) {
                const element = {
                    value: row.Type,
                    label: row.Type
                }
                actualTypes.push(element)
            }
        }


        const temporal = this.state.General
        temporal.generalHistory = n
        temporal.generalHistoryFilter = n
        temporal.optionsSelect1 = actualTypes
        this.setState({ General: temporal })
    }


    async getGeneralHistory(itemCode) {
        const tempo = this.state.General
        tempo.outBounds = []
        this.setState({ General: tempo })
        this.handleModalOpen("showModal3")
        this.displaySnipper('snipperDetail', '')
        //this.setState({secureTransaction1:true})
        const temporal = this.state.General
        temporal.selectedItem = itemCode
        temporal.generalHistory = []
        temporal.generalHistoryFilter = []
        const data = {
            ItemCode: itemCode.ItemCode,
            company: getValueCookie('Company'),
            Date: FormatQueryReturnDate(this.state.cycleInventoryStorage.Header.startDate)
        }

        // backv3 (temporal, regresar cuando backv3 esté listo): const val = await getInformationWithData('/pickList/history/getOutBound', data)
        const val = await getInformationWithDataV2('/pickList/history/getOutBound', data)
        // backv3 (temporal, regresar cuando backv3 esté listo): const val2 = await getInformationWithData('/invoice/history/getCurrentInvoice', data)
        const val2 = await getInformationWithDataV2('/invoice/history/getCurrentInvoice', data)
        //const val2 = await getInformationWithData('/purchase/history/getFutureByItemCode', data)
        if (val.status.code === 1 && val2.status.code === 1) {
            var arr = []
            for (const row of val.data) {
                const element = {
                    Type: row.Type,
                    Number: row.Num,
                    BIN: row.BIN,
                    QuantityOrdered: row.QuantityOrdered,
                    QuantityShipped: row.QuantityShipped,
                    username: row.username,
                    date: row.CreationDate
                }
                if (FormatQueryReturnDate(row.CreationDate).split("/").length === 3) {
                    element.date = FormatQueryReturnDate(row.CreationDate)
                } else {
                    element.date = DateFormatMAS90(row.CreationDate)
                }



                arr.push(element)
            }

            for (const row of val2.data) {
                const element = {
                    Type: row.Type,
                    Number: row.InvoiceNo,
                    BIN: row.BIN,
                    QuantityOrdered: row.QuantityOrdered,
                    QuantityShipped: row.QuantityShipped,
                    username: row.SalespersonNo,
                    date: row.InvoiceDate
                }
                if (FormatQueryReturnDate(row.InvoiceDate).split("/").length === 3) {
                    element.date = FormatQueryReturnDate(row.InvoiceDate)
                } else {
                    element.date = DateFormatMAS90(row.InvoiceDate)
                }


                arr.push(element)
            }

            temporal.outBounds = arr
            this.displaySnipper('snipperDetail', 'none')
        }

        /* if (val2.status.code === 1) {
             temporal.purchaseOrders = val2.data
 
         }
         */

        this.setState({ General: temporal })
        //this.setState({secureTransaction1:false})

    }

    async updateSystemQuantity(item) {

        this.setState({ secureTransaction: true })
        Swal.fire({
            title: 'For this Action you need a User and  Password Admin. Please enter it to continue:',
            html: `<input type="text" id="loginChangeQuantity" className="swal2-input" placeholder="Username">
  <input type="password" id="passwordChangeQuantity" className="swal2-input" placeholder="Password">`,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const login = Swal.getPopup().querySelector('#loginChangeQuantity').value
                const password = Swal.getPopup().querySelector('#passwordChangeQuantity').value
                if (!login || !password) {
                    Swal.showValidationMessage(`Please enter login and password`)
                } else if (login === "diego.perez" && password === "Diego1560") {
                    automaticCloseAlert('correct', 'The Quantity has been updated!')
                } else {
                    automaticCloseAlert('incorrect', 'Username or password are invalid!')
                }

            },
            allowOutsideClick: () => !Swal.isLoading()
        })
        this.setState({ secureTransaction: false })
    }

    async getCheckedItems() {
        const data = {
            id: this.state.cycleInventoryStorage.Header.id,
            idcompany: getValueCookie('CompanyId'),
            company: getValueCookie('Company')
        }
        const route = '/inventory/cycledetail/post';
        // backv3 (temporal, regresar cuando backv3 esté listo): const datos = await getInformationWithData(route, data)
        const datos = await getInformationWithDataV2(route, data)
        return datos.data
    }

    generateInfo() {

        let proccessInfo = JSON.parse(JSON.stringify(this.state.cycleInventoryStorage.DetailFilter))
        const headerKeys = ['ItemCode', 'productLine', 'Description', 'realQuantity', 'systemQuantity', 'difference', 'countBy', 'date', 'status', 'comentary']
        for (const item of proccessInfo) {
            for (const head of headerKeys) {
                if (head !== "status") {
                    if (item[head] === null || item[head] === "null") {
                        item[head] = ""
                    } else if (head === "date") {
                        item[head] = FormatQueryReturnDate(item[head])
                    }
                } else {
                    if (item[head] === 0) {
                        item[head] = "Not checked"
                    } else {
                        item[head] = "Checked"
                    }
                }

            }
        }

        var info = getDataSet(proccessInfo,
            ['Item Code', 'Product Line', 'Description', 'Quantity', 'System Quantity', 'Difference', 'Counted By', 'Date', 'Status', 'Comments'],
            headerKeys)
        //this.setState({dataset:info})
        return info
    }

    async addComentary(item) {
        this.disableTransaction()
        var comm = ""
        if (item.comentary) {
            comm = item.comentary
        }


        Swal.fire({
            title: 'Product: ' + item.ItemCode + ' \nBIN: ' + item.BIN,
            html: `<div class='textAreaGeneral textAreaComment'>
                    <textarea id='comentOfCycleInventoryDifference' rows="10" cols="50">${comm}</textarea>
                   </div>
            `,
            backdrop: true,
            showCancelButton: true,
            confirmButtonText: 'Save Commentary',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                const coment = Swal.getPopup().querySelector('#comentOfCycleInventoryDifference').value
                const temporal = this.state.cycleInventoryStorage
                const index = temporal.Detail.indexOf(item)
                if (index !== -1) {
                    temporal.Detail[index].comentary = coment
                    const response = await create_Delete_Update_Information('/invertory/updateDetailCycle/post', temporal.Detail[index])
                    if (response.status.code === 1) {
                        automaticCloseAlert('correct', 'The comment was save!')
                        await this.setState({ cycleInventoryStorage: temporal })
                    } else {
                        automaticCloseAlert('incorrect', 'The comment was not save')
                    }
                }

            },
            allowOutsideClick: () => !Swal.isLoading()
        })
        await this.enableTransaction()
    }

    onChangeQuantity = (item, e) => {
        const temp = this.state.cycleInventoryStorage
        const index = temp.Detail.indexOf(item)
        if (index !== -1) {
            temp.Detail[index].realQuantity = Number(e.target.value)
        }
    }

    addDifferenceSymbol(diff) {
        if (diff < 0) {
            return ""
        } else {
            return "+"
        }
    }
    RemainingDays(date) {
        var actual = getDateYearMonthDayDash()
        var start = FormatQueryReturnDateWithDash(date)
        var date3 = new Date(start)
        var date4 = new Date(actual)
        var date5 = new Date(start)
        var date6 = new Date(actual)
        var difference = Math.abs(date4 - date3);

        var preliminarDays = difference / (1000 * 3600 * 24)
        var inhDays = 0
        while (date4 <= date3) {
            if (date4.getDay() === 0 || date4.getDay() === 6) {
                inhDays++
            }
            date4 = new Date(date4.getTime() + 86400000)
        }

        if (date6 > date5) {
            return ((preliminarDays - inhDays) * -1).toFixed(0)
        } else {

            return (preliminarDays - inhDays).toFixed(0)
        }


    }

    onChangeFilterHistory = (e) => {
        if (e.value !== 'All') {
            var DetailFilter = this.state.General.generalHistory.filter((item) => {
                if (item.Type.toString().toLowerCase().includes(e.value.toLowerCase())) {
                    return item
                } else {
                    return null
                }
            })
            const temporal = this.state.General
            temporal.generalHistoryFilter = DetailFilter
            this.setState({ General: temporal })
        } else {
            const temporal = this.state.General
            temporal.generalHistoryFilter = temporal.generalHistory
            this.setState({ General: temporal })
        }

    }

    generateExcelDataForHistory() {
        const headers = ["Type", "No Order", "Customer No", "Customer Name", "BIN", "New BIN", `Quantity Order/Old Quantity`, `Quantity Shipped/New Quantity`, "Difference", "Description", "Username", "Date"]
        const keys = ["Type", "NoOrder", "CustomerNo", "CustomerName", "BIN", "BIN2", "QuantityOrder", "QuantityShipped", "difference", "Description", "User", "Date"]
        var copyOfHistory = this.state.General.generalHistoryFilter
        for (const row of copyOfHistory) {

            if (row.Type === "Purchase") {
                row.difference = "+" + row.QuantityOrder
            } else if (row.Type === "Ajuste" || row.Type === "Transferencia") {
                row.difference = this.addDifferenceSymbol(Number(row.QuantityShipped) - Number(row.QuantityOrder)) + (Number(row.QuantityShipped) - Number(row.QuantityOrder))
            } else if (row.Type === "Outbounds" || row.Type === "Invoice") {
                row.difference = "-" + row.QuantityShipped
            }

            for (const key of keys) {
                if (row[key] === null || row[key] === undefined) {
                    row[key] = '-'
                }
            }

        }

        var info = getDataSet(copyOfHistory, headers, keys)
        return info
    }

    getKPI() {
        var DetailFilter1 = this.state.cycleInventoryStorage.Detail.filter((item) => {
            if (item.status === 1) {
                return item
            } else {
                return null
            }
        })

        var DetailFilter3 = this.state.cycleInventoryStorage.Detail.filter((item) => {
            if (item.difference !== 0) {
                return item
            } else {
                return null
            }
        })
        var total = 100 - (DetailFilter3.length / DetailFilter1.length)
        return total.toFixed(2)
    }

    displaySnipper(id, state) {
        let snipper = document.getElementById(id)
        if (snipper) {
            snipper.style.display = state
        } else {
        }
    }

    async requestGetOrder(query, payload){
        let responseData =  [];
        await axios.post(`${server.url}${query}`, payload).then(
            response => {
                if (response.data.status.code === 1){
                    responseData = response.data.data;
                }
            }
        ).catch(error => {
            console.log(error)
            Swal.fire({
                icon: "error",
                title: "Please try again. If the problem persists contanct the IT Team.",
            });
            // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
        })
        return responseData
    }

    async showOrder(noOrder){
        this.setState({showOrderDetailModal: {open: true, noOrder}})
        const isPO = noOrder.includes('PO');
        let showOrderDetails = [];
        if (isPO){
            const payload = {
                data: {
                    NoOrder: noOrder,
                    idcompany: "3"
                }
            }
            const purchaseQuery = "/purchase/get/purchaseOrderDetail"
            showOrderDetails = await this.requestGetOrder(purchaseQuery, payload);
            this.setState({ showOrderDetails })
        } else {
            const payloadInvoice = {
                data: {
                    idCompany: 3,
                    CustomerNo: "*",
                    search: noOrder
                }
            }
            const invoiceQuery = "/invoice/history/header";
            const invoiceOrder = await this.requestGetOrder(invoiceQuery, payloadInvoice);
            const payloadSales = {
                data: {
                    idcompany: 3,
                    idCompany: 3,
                    OrderNo: invoiceOrder[0].SalesOrderNo
                }
            }
            const salesQuery = "/sales/get/detail";
            const showOrderDetails = await this.requestGetOrder(salesQuery, payloadSales);

            this.setState({ showOrderDetails: showOrderDetails.Tabla2 })
        }
    }

    setLocaleDate(rawDate){
        return new Date(rawDate).toLocaleString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        })
    }

    render() {
        const hasActive = this.state.cycleInventoryStorage.Header.status === 0;
        const hdr = this.state.cycleInventoryStorage.Header;
        const remainingDays = isNaN(this.RemainingDays(hdr.finishDate)) ? '-' : this.RemainingDays(hdr.finishDate);
        const kpi = isNaN(this.getKPI()) ? '0' : this.getKPI();
        const sortArrows = (s) => (
            <span style={{ marginLeft: '3px', opacity: 0.5, fontSize: '0.7rem' }}>▲▼</span>
        );

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />
                <button hidden id='actionatorCycleInventory' onClick={() => this.getLastCycleInventory()}></button>

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Cyclical Inventory</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasActive ? `Cycle #${hdr.id} · Started ${formatInputDateQuery(hdr.startDate)}` : 'No active cycle — start a new one'}
                        </p>
                    </div>
                    <div style={{ display: 'flex', gap: '0.625rem', flexWrap: 'wrap' }}>
                        {hasActive ? (
                            <button disabled={this.state.General.secureTransaction} onClick={() => this.endCycleInventory()}
                                style={{ background: 'rgba(239,68,68,0.2)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: '8px', color: '#FCA5A5', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer' }}>
                                End Cycle
                            </button>
                        ) : (
                            <button disabled={this.state.General.secureTransaction} onClick={() => this.startNewCycleInventory()}
                                style={{ background: 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.4)', borderRadius: '8px', color: '#6EE7B7', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer' }}>
                                Start New Cycle
                            </button>
                        )}
                        <button onClick={() => this.openOlCycleInventory()}
                            style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer' }}>
                            History
                        </button>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Active cycle info + progress */}
                    {hasActive ? (
                        <div className="row g-3 mb-3">
                            {/* Cycle metadata */}
                            <div className="col-12 col-md-8">
                                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Cycle Information</span>
                                    </div>
                                    <div className="card-body">
                                        <div className="pol-card__grid">
                                            {[
                                                { l: 'Start Date', v: formatInputDateQuery(hdr.startDate) },
                                                { l: 'Proposed End', v: formatInputDateQuery(hdr.finishDate) },
                                                { l: 'Est. Days', v: hdr.days },
                                                { l: 'Remaining Days', v: remainingDays },
                                            ].map((f, i) => (
                                                <div key={i} className="pol-kv-box">
                                                    <span>{f.l}</span>
                                                    <strong>{f.v || '—'}</strong>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* KPIs */}
                            <div className="col-12 col-md-4 d-flex flex-column gap-3">
                                <div className="metric-card status-primary">
                                    <div className="metric-label">Total Items</div>
                                    <div className="metric-value">{hdr.QuantityItems}</div>
                                    <div className="metric-change">In this cycle</div>
                                </div>
                                <div className="metric-card status-success">
                                    <div className="metric-label">KPI</div>
                                    <div className="metric-value">{kpi}%</div>
                                    <div className="metric-change">Accuracy</div>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {/* Progress bar + filter */}
                    {hasActive ? (
                        <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>
                                    Progress — {this.state.cycleInventoryStorage.actualTitleSearch} ({hdr.FilterQuantity} items)
                                </span>
                                <ExcelDocument hidden={false} data={this.generateInfo()} sheetname={"CycleInventoryDetail"} archname={"CYCLICAL INVENTORY NO " + hdr.id + " COMPANY " + getValueCookie('Company') + " DATE " + getDateFromReports()} />
                            </div>
                            <div className="card-body">
                                <div className="row g-3 align-items-center">
                                    <div className="col-12 col-md-6 text-center">
                                        <ProgressBar ref={this.ProgrressBarRef} />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                            {[{ v: '-1', l: 'All' }, { v: '0', l: 'Not Checked' }, { v: '1', l: 'Checked' }, { v: '2', l: 'Differences' }].map(opt => (
                                                <label key={opt.v} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', padding: '0.35rem 0.875rem', borderRadius: '999px', cursor: 'pointer', userSelect: 'none', fontWeight: 700, fontSize: '0.8rem', background: this.state.General.chekvalue === opt.v ? 'linear-gradient(135deg, #0f172a, #1e3a8a)' : '#F1F5F9', color: this.state.General.chekvalue === opt.v ? 'white' : '#475569', border: 'none' }}>
                                                    <input type="radio" value={opt.v} onChange={this.valueRadioButton} checked={this.state.General.chekvalue === opt.v} name="flexRadioDefault" style={{ display: 'none' }} />
                                                    {opt.l}
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {/* Search + table */}
                    {hasActive ? (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                <AiOutlineSearch style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1rem' }} />
                                <input type="text" autoComplete='off' placeholder='Search by ItemCode, BIN, Description...' id='searchCycleInv1' onChange={this.valueSearchBar}
                                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem', flex: 1, outline: 'none' }} />
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className='table table-clean mb-0'>
                                    <thead>
                                        <tr className="text-center">
                                            <th>Item Code</th>
                                            <th>Product Line</th>
                                            <th className="text-start">Description</th>
                                            <th>Last Due Date</th>
                                            <th>Quantity</th>
                                            <th>System Qty</th>
                                            <th>Difference</th>
                                            <th>Counted By</th>
                                            <th>Status</th>
                                            <th style={{ width: 36 }}></th>
                                            <th style={{ width: 90 }}></th>
                                            <th style={{ width: 36 }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.cycleInventoryStorage.DetailFilter.map((item, i) => {
                                            const checked = item.status === 1;
                                            return (
                                                <tr key={i} className="text-center" style={{ background: checked ? 'rgba(16,185,129,0.03)' : 'white' }}>
                                                    <td>
                                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{item.ItemCode}</span>
                                                    </td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.productLine}</td>
                                                    <td className="text-start" style={{ fontSize: '0.875rem', color: '#334155' }}>{item.Description}</td>
                                                    <td style={{ fontSize: '0.8rem', color: '#94A3B8' }}>{item.LastDueDate ? FormatQueryReturnDate(item.LastDueDate) : '—'}</td>
                                                    <td>
                                                        <input disabled={checked} type="number" key={item.realQuantity} defaultValue={item.realQuantity} id={"realQuantityCycleInv_" + item.id}
                                                            style={{ width: '70px', textAlign: 'center', border: '1.5px solid #E2E8F0', borderRadius: '6px', padding: '4px 6px', fontSize: '0.875rem' }}
                                                            onChange={(e) => this.onChangeQuantity(item, e)} />
                                                    </td>
                                                    <td style={{ fontSize: '0.875rem' }}>{checked ? item.systemQuantity : '—'}</td>
                                                    <td>
                                                        {checked ? (
                                                            <span style={{ fontWeight: 700, color: item.difference === 0 ? '#059669' : item.difference < 0 ? '#DC2626' : '#D97706' }}>
                                                                {item.difference > 0 ? '+' : ''}{item.difference}
                                                            </span>
                                                        ) : '—'}
                                                    </td>
                                                    <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.countBy || '—'}</td>
                                                    <td>
                                                        <span style={{ background: checked ? 'rgba(16,185,129,0.08)' : 'rgba(239,68,68,0.06)', color: checked ? '#059669' : '#DC2626', border: `1px solid ${checked ? '#A7F3D0' : '#FECACA'}`, borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                            {checked ? 'Checked' : 'Pending'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button type="button" onClick={() => this.addComentary(item)} disabled={this.state.General.secureTransaction || !checked}
                                                            style={{ background: '#F1F5F9', border: 'none', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#64748B', opacity: !checked ? 0.4 : 1 }}>
                                                            <AiOutlineComment />
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {!checked ? (
                                                            <button type="button" disabled={this.state.General.secureTransaction} onClick={() => this.setCycleInventoryDetailInfo(item, "realQuantityCycleInv_" + item.id)}
                                                                style={{ background: 'rgba(16,185,129,0.1)', border: '1px solid #A7F3D0', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', color: '#059669', fontWeight: 700, fontSize: '0.78rem' }}>
                                                                <AiOutlineCheck /> Check
                                                            </button>
                                                        ) : (
                                                            <button type="button" disabled={this.state.General.secureTransaction} onClick={() => this.updateCycleInventoryDetail(item)}
                                                                style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid #FECACA', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', color: '#DC2626', fontWeight: 700, fontSize: '0.78rem' }}>
                                                                Undo
                                                            </button>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <button disabled={this.state.secureTransaction1} onClick={() => this.getGeneralHistory(item)} type="button"
                                                            style={{ background: 'rgba(37,99,235,0.08)', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '4px 8px', cursor: 'pointer', color: '#1e40af', fontSize: '0.875rem' }}>
                                                            <AiOutlineSearch />
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={12} style={{ color: '#94A3B8', fontSize: '0.8rem', fontWeight: 500 }}>
                                                {hdr.FilterQuantity} items · {this.state.cycleInventoryStorage.CheckedItems.length} checked
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <BsBoxSeam style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>No active cyclical inventory. Click <strong>Start New Cycle</strong> to begin.</p>
                        </div>
                    )}

                </div>

                {/* Modal — Old Cyclical Inventory */}
                <ModalOrders title={'Cyclical Inventory History'} show={this.state.General.showModal2} close={(modal = "showModal2") => this.handleModalClose(modal)}>
                    <div className='row pt-3'>
                        <div className='col-12 pb-3'>
                            <p style={{ color: '#64748B', fontSize: '0.875rem' }}>Select a past cycle to view its detail:</p>
                        </div>
                        <div className='col-12 tableFixHeadSmall mb-3'>
                            <table className='table table-clean mb-0'>
                                <thead>
                                    <tr className="text-center">
                                        <th>Id</th><th>Start Date</th><th>Est. End</th><th>Real End</th><th>Days</th><th>Created By</th><th>Closed By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.General.oldCycleInventory.map((item, i) => (
                                        <tr key={i} onClick={() => this.getOldDetailCycleInventory(item)} style={{ cursor: 'pointer', background: this.state.General.selectedCycleInventory === item ? '#EFF6FF' : 'white', borderLeft: this.state.General.selectedCycleInventory === item ? '3px solid #2563EB' : '3px solid transparent' }} className="text-center">
                                            <td style={{ fontWeight: 700 }}>{item.id}</td>
                                            <td>{item.startDate2}</td><td>{item.finishDate2}</td><td>{item.realFinishDate2}</td>
                                            <td>{item.realQuantityDays}</td><td>{item.createBy}</td><td>{item.closeBy}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className='col-12 pb-2' style={{ fontWeight: 700, color: '#334155', fontSize: '0.875rem' }}>Detail</div>
                        <div className='col-12 pb-3'>
                            <div style={{ position: 'relative' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                <input type="text" className="form-control" placeholder='Search by BIN, Description, Status...' id='searchOldCycleInv' onChange={this.searchOlderCycleInventoryDetail}
                                    style={{ paddingLeft: '2rem', borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem' }} />
                            </div>
                        </div>
                        <div className='col-12 pb-3'>
                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                                {[{ cls: 'correctCount2', l: 'Exact diff.' }, { cls: 'negativeCount2', l: 'Negative diff.' }, { cls: 'positiveCount2', l: 'Positive diff.' }].map((b, i) => (
                                    <span key={i} className={b.cls} style={{ padding: '4px 10px', borderRadius: '6px', fontSize: '0.75rem', fontWeight: 700 }}>{b.l}</span>
                                ))}
                            </div>
                        </div>
                        <div className='col-12 tableFixHeadSmall'>
                            <table className='table table-clean mb-0'>
                                <thead>
                                    <tr className="text-center">
                                        <th>Item Code</th><th>Description</th><th>Qty</th><th>BIN</th>
                                        <th>System Qty</th><th>Difference</th><th>Counted By</th><th>Status</th><th>Comments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.General.detailOldCycleSelectedFilter.map((item, i) => (
                                        <tr key={i} className={item.status === 0 ? 'notcounted' : item.difference < 0 ? 'negativeCount' : item.difference === 0 ? 'correctCount' : 'positiveCount'}>
                                            <td className='text-center'>
                                                <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{item.ItemCode}</span>
                                            </td>
                                            <td>{item.Description}</td>
                                            <td className='text-center'>{item.status === 0 ? "—" : item.realQuantity}</td>
                                            <td className='text-center'>{(item.BIN && item.BIN !== 'null') ? item.BIN : "—"}</td>
                                            <td className='text-center'>{item.status === 0 ? "—" : item.systemQuantity}</td>
                                            <td className='text-center' style={{ fontWeight: 700 }}>{item.status === 0 ? "—" : item.difference}</td>
                                            <td className='text-center'>{item.countBy || "—"}</td>
                                            <td className='text-center'>
                                                <span style={{ background: item.status === 1 ? 'rgba(16,185,129,0.08)' : 'rgba(239,68,68,0.06)', color: item.status === 1 ? '#059669' : '#DC2626', border: `1px solid ${item.status === 1 ? '#A7F3D0' : '#FECACA'}`, borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                    {this.textStatus(item.status)}
                                                </span>
                                            </td>
                                            <td className='text-center' style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.comentary === 'null' ? '—' : item.comentary}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ModalOrders>
                <ModalOrders title={'Product Detail'} show={this.state.General.showModal3} close={(modal = "showModal3") => this.handleModalClose(modal)}>
                    {/* Item header */}
                    <div className="row mb-3 align-items-center">
                        <div className="col-auto">
                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '8px', padding: '4px 12px', fontSize: '0.9rem', fontWeight: 800 }}>
                                {this.state.General.selectedItem.ItemCode}
                            </span>
                        </div>
                        <div className="col">
                            <div style={{ fontWeight: 600, color: '#334155', fontSize: '0.9rem' }}>{this.state.General.selectedItem.Description}</div>
                        </div>
                    </div>

                    {/* Open orders alert */}
                    <div style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid #FECACA', borderRadius: '10px', padding: '0.75rem 1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <div className="spinner-border text-danger" id='snipperDetail' role="status" style={{ width: '1rem', height: '1rem', borderWidth: '2px' }}></div>
                        <span style={{ color: '#DC2626', fontSize: '0.875rem', fontWeight: 600 }}>Orders that may affect current physical inventory</span>
                    </div>
                    <div className='tableFixHeadSmall mb-3'>
                        <table className='table table-clean mb-0'>
                            <thead>
                                <tr className="text-center">
                                    <th>Type</th><th>Number</th>
                                    <th hidden={getValueCookie('CompanyId') === "3"}>BIN</th>
                                    <th>Qty Ordered</th><th>Qty Shipped</th><th>User</th><th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.General.outBounds.map((item, i) => (
                                    <tr key={i} className="text-center">
                                        <td><span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '5px', padding: '1px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{item.Type}</span></td>
                                        <td className="text-start">{item.Number}</td>
                                        <td hidden={getValueCookie('CompanyId') === "3"}>{item.BIN}</td>
                                        <td>{item.QuantityOrdered}</td><td>{item.QuantityShipped}</td>
                                        <td style={{ color: '#64748B', fontSize: '0.8rem' }}>{item.username}</td>
                                        <td style={{ color: '#64748B', fontSize: '0.8rem' }}>{item.date}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* History search */}
                    <div style={{ background: '#F8FAFC', borderRadius: '10px', padding: '0.875rem 1rem', marginBottom: '1rem', border: '1px solid #E2E8F0' }}>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.625rem' }}>Search History</div>
                        <div className="row g-2 align-items-end">
                            <div className="col"><input type="date" className="form-control form-control-sm" id='searchHistoryCycleInvDate1' style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} /></div>
                            <div className="col"><input type="date" className="form-control form-control-sm" id='searchHistoryCycleInvDate2' style={{ borderRadius: '8px', border: '1.5px solid #E2E8F0' }} /></div>
                            <div className="col-auto">
                                <button disabled={this.state.secureTransaction1} onClick={() => this.getInfoProduct()}
                                    style={{ background: 'linear-gradient(135deg, #0f172a, #1e3a8a)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.4rem 1rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer' }}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row g-2 align-items-center mb-2">
                        <div className="col"><Select defaultValue={this.state.General.optionsSelect1[0]} options={this.state.General.optionsSelect1} onChange={this.onChangeFilterHistory} /></div>
                        <div className="col-auto">
                            <ExcelDocument hidden={this.state.General.generalHistoryFilter.length === 0} data={this.generateExcelDataForHistory()} sheetname={"History ITEM " + this.state.General.selectedItem.ItemCode} archname={"History Product " + this.state.General.selectedItem.ItemCode + " " + getValueCookie('Company') + " " + getDateFromReports()} />
                        </div>
                    </div>
                    <div className='tableFixHeadSmall'>
                        <table className='table table-clean mb-0'>
                            <thead>
                                <tr className="text-center">
                                    <th>Type</th><th>No Order</th>
                                    <th hidden={getValueCookie('CompanyId') === '2'}>Customer No</th>
                                    <th hidden={getValueCookie('CompanyId') === '2'}>Customer Name</th>
                                    <th>BIN</th>
                                    <th hidden={getValueCookie('CompanyId') === '3'}>New BIN</th>
                                    <th>Qty Order</th><th>Qty Shipped</th><th>Balance</th>
                                    <th>Description</th><th>User</th><th>Date</th><th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.General.generalHistoryFilter.map((item, i) => (
                                    <tr key={i} className={'text-center ' + ((item.Type === 'Inventory Start' || item.Type === 'Inventory End') ? (item.Type === 'Inventory Start' ? 'correctCount' : 'positiveCount') : '')}>
                                        <td className="text-start"><span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '5px', padding: '1px 6px', fontSize: '0.72rem', fontWeight: 700 }}>{item.Type}</span></td>
                                        <td className="text-start" style={{ fontSize: '0.8rem' }}>{item.NoOrder}</td>
                                        <td hidden={getValueCookie('CompanyId') === '2'} style={{ fontSize: '0.8rem' }}>{item.CustomerNo}</td>
                                        <td hidden={getValueCookie('CompanyId') === '2'} className="text-start" style={{ fontSize: '0.8rem' }}>{item.CustomerName}</td>
                                        <td>{item.BIN}</td>
                                        <td hidden={getValueCookie('CompanyId') === '3'}>{item.BIN2}</td>
                                        <td>{item.QuantityOrder}</td><td>{item.QuantityShipped}</td>
                                        <td style={{ fontWeight: 700 }}>{(item.Type === "Transferencia" || item.Type === "Ajuste") ? this.addDifferenceSymbol(Number(item.QuantityShipped) - Number(item.QuantityOrder)) + (Number(item.QuantityShipped) - Number(item.QuantityOrder)) : ((item.Type === 'Outbound' || item.Type === 'Purchase' || item.Type === 'Invoice') ? ((item.Type === 'Outbound' || item.Type === 'Invoice') ? "-" + item.QuantityShipped : "+" + item.QuantityOrder) : '—')}</td>
                                        <td className="text-start" style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.Description}</td>
                                        <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.User}</td>
                                        <td style={{ fontSize: '0.8rem', color: '#94A3B8' }}>{item.Date}</td>
                                        <td>
                                            <button style={{ background: 'rgba(37,99,235,0.08)', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', color: '#1e40af', fontSize: '0.875rem' }} onClick={() => this.showOrder(item.NoOrder)}>
                                                <AiOutlineSearch />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </ModalOrders>
                {/* Order Detail Modal */}
                {this.state.showOrderDetailModal.open && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1059, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ background: 'white', borderRadius: '16px', width: 'min(900px, calc(100vw - 2rem))', maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', zIndex: 1060 }}>
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <div style={{ color: 'white', fontWeight: 700, fontSize: '1rem' }}>Order Detail</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginTop: '2px' }}>{this.state.showOrderDetailModal.noOrder}</div>
                                </div>
                                <button onClick={() => this.setState({ showOrderDetailModal: {} })} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '1.25rem', cursor: 'pointer' }}>✕</button>
                            </div>
                            <div style={{ overflowY: 'auto', flex: 1 }}>
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th>Item</th><th className="text-start">Description</th><th>Qty Ordered</th>
                                            <th>{this.state.showOrderDetailModal.noOrder && this.state.showOrderDetailModal.noOrder.startsWith('PO') ? 'Qty Received' : 'Qty Shipped'}</th>
                                            <th>Date</th><th>User</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.showOrderDetails.map((item, index) => (
                                            <tr key={index} className="text-center">
                                                <td><span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{item.ItemCode}</span></td>
                                                <td className="text-start" style={{ fontSize: '0.875rem', color: '#334155' }}>{item.completeDesc || item.ItemCodeDesc}</td>
                                                <td>{item.QuantityOrdered}</td>
                                                <td style={{ fontWeight: 700 }}>{item.QuantityReceived || item.QuantityShipped}</td>
                                                <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{this.setLocaleDate(item.receivedDate) || this.setLocaleDate(item.DispatchDate)}</td>
                                                <td style={{ fontSize: '0.8rem', color: '#64748B' }}>{item.receivedBy || item.DispatchUser}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ padding: '0.875rem 1.5rem', borderTop: '1px solid #E2E8F0', display: 'flex', justifyContent: 'flex-end' }}>
                                <button onClick={() => this.setState({ showOrderDetailModal: {} })}
                                    style={{ background: 'linear-gradient(135deg, #0f172a, #1e3a8a)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer' }}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}